import { useNavigate } from "react-router";
import { useFavouriteLike } from "../../actions/dashboardActions";
export default () => {
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const {
    data: eventsData,
    isLoading,
    isError,
    error,
  } = useFavouriteLike(userId, "event");

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const handleEvents = (id) => {
    navigate(`/event-details/${id}`);
  };
  return { formatEventDate, eventsData, isLoading, handleEvents };
};
